export default "/assets/recipes.svg";